export const handleBackButtonClick = () => {
  window.history.back();
};
